'use strict';

function CrossPromo() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.extends = [];
  this.declaredClass = null;

  this._analytics = new Analytics();
  this._history = new History();
  this._session = new Session();

  this.presenter = null;
  this.type = null; // set to 'static' when no backend endpoint required
  this.delay = 3000;

  this.promoLayoutData = null;
  this.contentfulEntryIdData = null;
  this.promoClassData = null;
  this.inlinePromo = null;

  this._promoLayout = null;
  this._contentfulEntryId = null;
  this._promoClass = null;

  this._activePromoObj = null;

  this._classes = {
    promoViewCta: '.js--view-promo',
    promoRemindMeLaterCta: '.js--remind-me-later',
    promoImage: '.js--promo-image',
    contentfulTitle: '.js--contentful-title',
    contentfulContent: '.js--contentful-content',
    notificationCloseBtn: '.js--close-btn'
  };
  this.el = {};

  this.customHTML = null;

  this.init = function () {
    if (this.type !== 'static' && !this.presenter.hasAction('account.index_promotions') || !this.promoLayoutData && !this.contentfulEntryIdData) {
      console.error('Require: promoLayoutData, and contentfulEntryIdData');
      return false;
    }

    this.$node = $(this.node);
    this._notification = this.inlinePromo ? $('#NotificationInline') : $('#Notification');

    this.promotionsPromise = $.Deferred(); // Load Promotions Data

    // Kick things off
    this.retrievePromotions();

    $.when(this.promotionsPromise).then(this._onPromotionsLoadComplete.bind(this));

    // destroy when user navigates away from the page
    $(window).on('pushstate.promo', this._pushstateCallback.bind(this));
  };

  this._onPromotionsLoadComplete = function () {
    // Create promises so ajax requests can happen at once
    this.contentfulPromise = $.Deferred(); // Contentful Content
    this.tmplPromise = $.Deferred(); // Content Display Template
    this.markedPromise = this._loadMarked(); // To Process Markdown

    // Kick things off
    this._loadContentful();
    this._loadTmpl();

    // Call _setupCrossPromo once the Promises have resolved
    $.when(this.contentfulPromise, this.tmplPromise, this.markedPromise).then(this._setupCrossPromo.bind(this));
  };

  this.initAllReady = function () {};

  // Dependencies:

  this.retrievePromotions = function () {
    var createPromotionsModelPromise = $.Deferred();
    createPromotionsModelPromise.done(this.onPromotionsLoad.bind(this));
    this.presenter.createModel('promotions', { action: 'account.index_promotions' }, createPromotionsModelPromise);
  };

  this.onPromotionsLoad = function () {
    // This checks if the user should see a banner on this page
    if (this._hasValidPromo()) {
      this.promotionsPromise.resolve();
    }
  }.bind(this);

  this._loadContentful = function () {
    this._contentful = new Contentful(_ContentfulConfiguration, $.extend({}, ContentfulSpaceParams, { verboseLevel: 1 }) // verboseLevel 1 required to have revision # returned.
    );

    this._contentful.getResource('ENTRY', { entry_id: this._contentfulEntryId }, this.contentfulPromise.resolve.bind(this));
  };

  this._loadTmpl = function () {
    var _this = this;

    this.tmplFragment = document.createElement('div');
    $(this.tmplFragment).load(this._promoLayout, function (response, status, xhr) {
      if (status === 'success') _this.tmplPromise.resolve();
    }).bind(this);
  };

  this._loadMarked = function () {
    if (typeof marked === 'undefined') {
      return $.ajax({
        url: '/member/assets/javascripts/marked.min.js',
        dataType: 'script',
        cache: true
      });
    }
  };

  this._hasValidPromo = function () {
    var _this2 = this;

    var _promos = this.presenter.models.promotions.promotions;
    if (_promos.length < 1) {
      return false;
    }

    return _promos.some(function (promo) {
      // Has user previously clicked "Remind me later" for this promo?
      var hasSuppressedOffer = _this2._hasClickedRemindMeLater(promo.id);

      if (!hasSuppressedOffer) {
        _this2._activePromoObj = _promos.filter(function (obj) {
          return obj.id === promo.id;
        })[0];

        // so we can use its relLink later
        _this2.presenter.createModel('promotionsActivePromo', { data: _this2._activePromoObj });

        _this2._promoLayout = _this2.promoLayoutData[_this2._activePromoObj.promotion_type];
        _this2._contentfulEntryId = _this2.contentfulEntryIdData[_this2._activePromoObj.promotion_type];
        _this2._promoClass = _this2.promoClassData[_this2._activePromoObj.promotion_type];

        return !!_this2._promoLayout && !!_this2._contentfulEntryId;
      }
    });
  };

  this._hasClickedRemindMeLater = function (promoId) {
    return Cookies.get('suppress_promo_' + promoId) === 'true';
  };

  // UI Display:

  this._setupCrossPromo = function (data) {
    var _contentfulDataItem = data.items[0];
    var _contentfulTitle = _contentfulDataItem.header;
    var _contentfulContent = marked(_contentfulDataItem.bodyContent, {
      breaks: true
    });

    // inject data into template:
    $(this.tmplFragment).find(this._classes.contentfulTitle).text(_contentfulTitle);
    $(this.tmplFragment).find(this._classes.contentfulContent).html(_contentfulContent);

    this.customHTML = this.tmplFragment.innerHTML;

    // When the user has been on the Page for 3 seconds,
    // Then the Cross Promote Money Banner/Screen Appears
    if (this.customHTML !== null && this.customHTML !== '') {
      this._delayedMsg = setTimeout(this.showCrossPromo.bind(this), this.delay, _contentfulDataItem);
    }
  };

  this.showCrossPromo = function (promoData) {
    var inlineClass = this.inlinePromo ? 'notification--inline' : '';

    this._notification.mogo().create({
      type: 'custom',
      customClass: 'notification--cross-promo ' + this._promoClass + ' ' + inlineClass,
      msg: this.customHTML,
      isPersistent: true
    });

    this.el.promoViewCta = this._notification.find(this._classes.promoViewCta);
    this.el.promoRemindMeLaterCta = this._notification.find(this._classes.promoRemindMeLaterCta);
    this.el.notificationCloseBtn = this._notification.find(this._classes.notificationCloseBtn);
    this.el.promoImage = this._notification.find(this._classes.promoImage);
    this.el.promoContent = this._notification.find(this._classes.contentfulContent);

    // mogofy it...
    if (this.el.promoViewCta.length) this.el.promoViewCta.mogo().parse();
    if (this.el.promoRemindMeLaterCta.length) this.el.promoRemindMeLaterCta.mogo().parse();
    if (this.el.promoImage.length) this.el.promoImage.mogo().parse();
    this.el.promoContent.mogo().parse();
    // this.presenter.scanDOM(this._notification); regression in updateDOM is breaking content on the page

    // setup promo actions:
    if (this.el.promoViewCta.length) this.el.promoViewCta.on('click', this.onEngageCTA.bind(this));
    if (this.el.promoRemindMeLaterCta.length) {
      this.el.promoRemindMeLaterCta.on('click', this.onRemindMeLater.bind(this));
    }
    this.el.notificationCloseBtn.on('click.promo', this.onClose.bind(this));

    // Analytics:
    this._analytics.forcePushEvent('promo-banner-close-view', {
      xPromoContent: [this._activePromoObj.promotion_type],
      promoID: [promoData._id, promoData._revision]
    });
  };

  // Actions:

  this.onEngageCTA = function (e) {
    e.preventDefault();
    this.turnOffPromo();
    this._notification.mogo().hideNotification(0);
    this._history.goToUrl(e.target.href);
  };

  this.onRemindMeLater = function () {
    this.setSupressCookie();
    this._notification.mogo().hideNotification();
  };

  this.setSupressCookie = function (isForever) {
    var cookieName = 'suppress_promo_' + this._activePromoObj.id;
    var cookieValue = 'true';
    if (isForever) {
      Cookies.set(cookieName, cookieValue, { expires: 9999 });
    } else {
      Cookies.set(cookieName, cookieValue);
    }
  };

  this.onClose = function () {
    this.turnOffPromo();
    this._pushCloseAnaytics();
  };

  this.turnOffPromo = function () {
    var _putData = {
      show_promotion: false
    };

    this.presenter.performAction('promotionsActivePromo.update_promotion', _putData, this._onTurnOffPromo.bind(this));
  };

  this._onTurnOffPromo = function () {
    delete this.presenter.models.promotionsActivePromo;
    this.presenter.models.promotions.updateModel();
  };

  // Analytics:

  this._pushCloseAnaytics = function () {
    this._analytics.forcePushEvent('promo-banner-close');
  };

  this._pushstateCallback = function () {
    $(window).off('pushstate.promo');
    this.destroy();
  };

  this.destroy = function () {
    if (this.el.notificationCloseBtn) {
      this.el.notificationCloseBtn.off('click.promo');
    }
    if (this._notification.mogo().declaredClass) {
      this._notification.mogo().hideNotification(0);
    }

    if (this._delayedMsg) {
      clearTimeout(this._delayedMsg);
    }
  };
}